// extracted by mini-css-extract-plugin
export default {"vectorIcon":"HeaderBackButton_vectorIcon__hIu1A","vectorWrapper":"HeaderBackButton_vectorWrapper__ALDvx","kyc":"HeaderBackButton_kyc__ZR1fE","frame":"HeaderBackButton_frame__UwKAb"};